export default __webpack_public_path__ + "static/10_31-5a15cafd016a5658710e586093834601.png";